<template>
  <v-row :class="titleModel" class="title-a">
    <v-col class="pa-0 py-1" cols="12">
      <v-list two-line>
        <v-list-item class="pa-0" two-line>
          <v-list-item-content class="py-1">
            <v-list-item-title><h1 class="cb-font-size-1">{{ title }}</h1></v-list-item-title>
            <v-list-item-subtitle v-if="subtitle">{{ subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="action">
            <v-btn 
              :disabled="action.disabled"
              :loading="loading"
              :shaped="titleModel !== 'plain'"
              :text="titleModel === 'plain'"
              :title="action.title"
              color="primary"
              @click="$emit('actionClick',action)"
            >
              <v-icon>{{ action.icon }}</v-icon>
              <span class="ml-1">{{ action.title }}</span>
            </v-btn>
          </v-list-item-action>
          <slot name="action"></slot>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>
<script>

  export default {
    name: 'TitleWithAction',
    props: {
      title: String,
      subtitle: String,
      action: Object,
      loading: Boolean,
      titleModel: {
        type: String,
        default: 'border-bottom'
      }
    }
  }
</script>


<style lang="scss">
  @import "@/assets/styles/resources/colors.scss";

  .title-a {
    padding: 0 8px;

    .v-list {
      padding: 0;

      .v-list-item {
        padding-left: 0;
        padding-right: 0;

        .v-list-item__content {
          padding: 4px;
          padding-left: 0;
        }

        .v-avatar {
          background: $color_app_contrast_low;
          border: solid 1px $color_app_contrast_medium;
          border-radius: 4px !important;
        }
      }
    }

    &.border-bottom,
    &.plain {
      border-bottom: 1px solid $color_app_contrast_medium;
    }

    &.plain {
      h1 {
        font-size: 16px !important;
      }

      .v-list-item__subtitle {
        font-size: 12px !important;
      }

      .v-list-item__action {
        margin: 4px 0;
      }
    }
  }
</style>